import { ComponentType, FC } from "react";

import { getOriginAsset } from "./get-assets";
import { Assets } from "./model";

type Props<K extends keyof Assets> = {
  assetKey: K,
  className?: string,
  alt?: string,
};

const isComponentAsset = (asset: Assets[keyof Assets]): asset is ComponentType<{ className?: string }> => {
  return typeof asset === "function";
};

export const OriginAsset: FC<Props<keyof Assets>> = ({
  assetKey,
  className,
  alt = "",
}) => {
  const asset = getOriginAsset(assetKey);

  if (isComponentAsset(asset)) {
    const AssetComponent = asset;

    return <AssetComponent className={className} />;
  }

  return (
    <img
      alt={alt}
      className={className}
      src={asset}
    />
  );
};
